import { useTranslation } from 'react-i18next';

import { useAppSelector } from '~/modules/store';
import { selectCurrentTest } from '~/modules/tests/tests.selectors';

import * as S from './TestSidebarNotes.styled';
import TestSidebarNotesForm from './TestSidebarNotesForm';

const TestSidebarNotes = () => {
  const test = useAppSelector(selectCurrentTest);
  const { t } = useTranslation();

  if (!test) {
    return null;
  }

  return (
    <S.Container>
      <S.Title>{t('testSidebar.notes.title', 'Test notes')}</S.Title>
      <TestSidebarNotesForm testId={test.id} notes={test.notes} />
    </S.Container>
  );
};

export default TestSidebarNotes;
